import React from 'react';
import { styled } from '@mui/material/styles';
import Highlighter from 'react-highlight-words';
import { CustomIcon, Typography } from '@p81-common/ui';
import { NavLink } from 'react-router-dom';
import { ResultItemProps } from '../../types';
import createClasses from './styles';

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 0)
}));

const StyledNavLink = styled(NavLink)({
  textDecoration: 'none',
  color: 'inherit',
  '&:hover': {
    textDecoration: 'none',
    color: 'inherit'
  },
  '& *': {
    color: 'inherit',
    textDecoration: 'none'
  }
});

export const ResultItem = ({
  name,
  subtitle,
  searchText,
  customerId,
  icon,
  region
}: ResultItemProps) => {
  const classes = createClasses();
  const { iconSrc, component } = icon || {};
  const redirectLink = `/customers/all-tenants/${customerId}/general?jarvisRegion=${region}`;

  return (
    <StyledNavLink to={redirectLink}>
      <Container>
        {component
          ? component
          : iconSrc && <CustomIcon src={iconSrc} className={classes.icon} />}

        <div className={classes.textContainer}>
          <Typography variant="body2" className={classes.name}>
            <Highlighter
              highlightClassName={classes.highlight}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={name}
            />
          </Typography>

          <Typography variant="caption" className={classes.subtitle}>
            <Highlighter
              highlightClassName={classes.highlight}
              searchWords={[searchText]}
              autoEscape
              textToHighlight={subtitle}
            />
          </Typography>
        </div>
      </Container>
    </StyledNavLink>
  );
};
